import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import cn from 'classnames';

import { TAdminSupplementInquiryStatus } from '@interfaces/adminSupplements';
import { adminNewSupplementPendingNewSupplementSelector } from '@store/features/adminInquiries/newSupplement/selectors';
import { adminSupplementDetailsStatusSelector } from '@store/features/adminInquiries/supplementDetails/selectors';

import DetailsAtTop from './DetailsAtTop/DetailsAtTop';
import NewSupplement from './NewSupplement/NewSupplement';
import SupplementInformationForm from './SupplementInformationForm/SupplementInformationForm';
import { ISupplementInquiryDetailsProps } from './SupplementInquiryDetails.interface';

const SupplementInquiryDetails: FC<ISupplementInquiryDetailsProps> = ({ className }) => {
  const supplementStatus = useSelector(adminSupplementDetailsStatusSelector);
  const pendingNewSupplement = useSelector(adminNewSupplementPendingNewSupplementSelector);
  const isNew =
    supplementStatus === TAdminSupplementInquiryStatus.New && pendingNewSupplement === null;

  return (
    <Box className={cn('admin-supplement-inquiry-details', className)}>
      <DetailsAtTop />
      {isNew ? <NewSupplement /> : <SupplementInformationForm />}
    </Box>
  );
};

export default SupplementInquiryDetails;
